import { render, staticRenderFns } from "./ProspectDetail.vue?vue&type=template&id=59f5b580"
import script from "./ProspectDetail.vue?vue&type=script&lang=ts"
export * from "./ProspectDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports